import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { IntroductionRoutes } from './introduction-routes';
import { AssessmentRoutes, TaskRoutes } from './assessment-routes';
import SessionRequiredRoute from './session-required-route';

const Routes = (
	<Switch>
		{IntroductionRoutes.map((route, index) => {
			if (route.requireSessionID) {
				return (<SessionRequiredRoute key={`introduction_${index}`} path={route.path} exact component={route.component} />)
			} else {
				return (<Route key={`introduction_${index}`} path={route.path} exact component={route.component} />)
			}
		})}

		{AssessmentRoutes.map((route, index) => (
			<SessionRequiredRoute key={`assessment_${index}`} path={route.path} exact component={route.component} />
		))}

		{TaskRoutes.map((route, index) => (
			<SessionRequiredRoute key={`assessment_${index}`} path={route.path} exact component={route.component} />
		))}
	</Switch>
);

export default Routes;